import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  situation: 'Tu hijo empieza el instituto',
  pack1: 'No tienes herramientas para esa etapa',
  pack2: 'Protocolo completo para la transición académica'
}, {
  situation: 'Problemas de relaciones sociales',
  pack1: 'No está cubierto en profundidad',
  pack2: 'Tomo completo de habilidades sociales y amistades'
}, {
  situation: 'Tu hijo no quiere hacer nada solo',
  pack1: 'Tienes las bases del vínculo',
  pack2: 'Sistema completo de independencia progresiva'
}, {
  situation: 'Ansiedad escolar o miedo al colegio',
  pack1: 'No tienes protocolo específico',
  pack2: 'Guía completa para vencer la ansiedad con pasos exactos'
}, {
  situation: 'Las pantallas controlan su vida',
  pack1: 'Consejos generales',
  pack2: 'El Pacto de Pantallas: sistema familiar completo'
}, {
  situation: 'Quieres que sea independiente de adulto',
  pack1: 'Tienes la base emocional',
  pack2: 'Hoja de ruta completa: El Camino al Éxito'
}];
export function PackComparison() {
  return <section className="bg-surface-gray py-16 px-6" data-id="element-217">
      <div className="max-w-6xl mx-auto" data-id="element-218">
        <div className="text-center mb-12" data-id="element-219">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4" data-id="element-220">
            🕊️ ¿QUÉ AÑADE EL MEGAPACK 2?
          </h2>
          <p className="text-secondary text-lg max-w-2xl mx-auto" data-id="element-221">
            Descubre por qué la mayoría de padres eligen el sistema completo
            para asegurar el éxito a largo plazo de sus hijos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-222">
          {comparisons.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden flex flex-col" data-id="element-223">
              <div className="bg-navy p-4 text-center border-b-4 border-gold" data-id="element-224">
                <h4 className="text-gold text-xs font-bold uppercase tracking-wider mb-1" data-id="element-225">
                  Situación
                </h4>
                <p className="font-display font-bold text-white text-lg leading-tight" data-id="element-226">
                  {row.situation}
                </p>
              </div>

              <div className="p-5 flex-grow flex flex-col gap-4" data-id="element-227">
                <div className="bg-gray-50 rounded-xl p-4 border border-gray-200 flex-grow" data-id="element-228">
                  <div className="flex items-center gap-2 mb-2" data-id="element-229">
                    <div className="bg-gray-200 rounded-full p-1" data-id="element-230">
                      <X className="w-4 h-4 text-gray-500" data-id="element-231" />
                    </div>
                    <h5 className="font-bold text-gray-600 text-sm" data-id="element-232">
                      Solo con Pack 1
                    </h5>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed" data-id="element-233">
                    {row.pack1}
                  </p>
                </div>

                <div className="bg-gold/10 rounded-xl p-4 border border-gold/30 shadow-[0_0_15px_rgba(201,168,76,0.1)] flex-grow" data-id="element-234">
                  <div className="flex items-center gap-2 mb-2" data-id="element-235">
                    <div className="bg-gold rounded-full p-1" data-id="element-236">
                      <Check className="w-4 h-4 text-navy" data-id="element-237" />
                    </div>
                    <h5 className="font-bold text-navy text-sm" data-id="element-238">
                      Con Pack 1 + Pack 2
                    </h5>
                  </div>
                  <p className="text-navy font-semibold text-sm leading-relaxed" data-id="element-239">
                    {row.pack2}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy text-white rounded-3xl p-8 md:p-10 shadow-2xl relative overflow-hidden" data-id="element-240">
          <div className="absolute inset-0 bg-gradient-to-br from-gold/10 to-transparent pointer-events-none" data-id="element-241"></div>
          <h3 className="font-display text-2xl font-bold text-gold mb-4 text-center relative z-10" data-id="element-242">
            ✅ EL MEGAPACK 2 INCLUYE:
          </h3>
          <div className="grid md:grid-cols-2 gap-6 relative z-10" data-id="element-243">
            <div data-id="element-244">
              <h4 className="text-xl font-bold mb-3 border-b border-white/20 pb-1" data-id="element-245">
                5 Tomos Avanzados:
              </h4>
              <ul className="space-y-2" data-id="element-246">
                <li className="flex items-center gap-3" data-id="element-247">
                  <Check className="text-gold w-5 h-5" data-id="element-248" /> Tomo 6: Éxito en el
                  Colegio
                </li>
                <li className="flex items-center gap-3" data-id="element-249">
                  <Check className="text-gold w-5 h-5" data-id="element-250" /> Tomo 7: Habilidades
                  Sociales
                </li>
                <li className="flex items-center gap-3" data-id="element-251">
                  <Check className="text-gold w-5 h-5" data-id="element-252" /> Tomo 8: Independencia
                  Real
                </li>
                <li className="flex items-center gap-3" data-id="element-253">
                  <Check className="text-gold w-5 h-5" data-id="element-254" /> Tomo 9: Vencer la
                  Ansiedad
                </li>
                <li className="flex items-center gap-3" data-id="element-255">
                  <Check className="text-gold w-5 h-5" data-id="element-256" /> Tomo 10: El Camino al
                  Éxito
                </li>
              </ul>
            </div>
            <div data-id="element-257">
              <h4 className="text-xl font-bold mb-3 border-b border-white/20 pb-1" data-id="element-258">
                4 Bonos Adicionales:
              </h4>
              <ul className="space-y-2" data-id="element-259">
                <li className="flex items-center gap-3" data-id="element-260">
                  <Check className="text-gold w-5 h-5" data-id="element-261" /> Bono 4:
                  Responsabilidades en Casa
                </li>
                <li className="flex items-center gap-3" data-id="element-262">
                  <Check className="text-gold w-5 h-5" data-id="element-263" /> Bono 5: Límites sin
                  Culpa
                </li>
                <li className="flex items-center gap-3" data-id="element-264">
                  <Check className="text-gold w-5 h-5" data-id="element-265" /> Bono 6: Anti-Ansiedad
                  Express
                </li>
                <li className="flex items-center gap-3" data-id="element-266">
                  <Check className="text-gold w-5 h-5" data-id="element-267" /> Bono 7: El Pacto de
                  Pantallas
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}